<script setup>
import DesktopIcon from '@iconify-vue/ph/desktop';
import DeviceMobileIcon from '@iconify-vue/ph/device-mobile';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import SpinnerIcon from '@js/components/icons/SpinnerIcon.vue';
import { ref } from 'vue';

const { html, loading = false } = defineProps({
    html: {
        type: String,
        required: true,
    },
    loading: {
        type: Boolean,
        required: false,
    },
});

const viewport = ref('desktop');
</script>

<template>
    <div class="flex flex-col">
        <div class="mb-1 flex items-center justify-between gap-4">
            <div class="flex gap-2">
                <ActionButton
                    :type="viewport === 'desktop' ? 'primary' : 'secondary'"
                    :callback="() => (viewport = 'desktop')"
                    :icon="DesktopIcon"
                    size="small"
                />

                <ActionButton
                    :type="viewport === 'mobile' ? 'primary' : 'secondary'"
                    :callback="() => (viewport = 'mobile')"
                    :icon="DeviceMobileIcon"
                    size="small"
                />
            </div>

            <div v-if="$slots.actions" class="flex">
                <div class="flex gap-2">
                    <slot name="actions" />
                </div>
            </div>
        </div>

        <div
            class="relative h-[40rem] overflow-hidden rounded border border-gray-300 bg-gray-100"
        >
            <SpinnerIcon
                v-if="loading"
                class="absolute top-1/2 left-1/2 size-8 -translate-1/2 animate-spin fill-indigo-600 text-gray-200"
            />

            <iframe
                v-else
                class="mx-auto h-full bg-white transition-[width] duration-300"
                :class="
                    viewport === 'mobile'
                        ? 'w-[375px] border-x border-gray-300'
                        : 'w-full'
                "
                :srcdoc="html"
            />
        </div>
    </div>
</template>
